import LayoutTablet from "@/layouts/tablet/layout-tablet.vue"
import oBlock from "@/objects/o-block/o-block.vue"
import oButton from "@/objects/o-button/o-button.vue"
import oIconQrCode from "@/objects/o-icon/qr-code.vue"
import oIconSms from "@/objects/o-icon/sms.vue"
import oIconEmail from "@/objects/o-icon/email.vue"
import Notification from '@/utils/Notification'

export default {
  name: "vElements",
  components: {
    "layout-tablet": LayoutTablet,
    "o-button": oButton,
    "o-block": oBlock,
    "o-icon-qr-code": oIconQrCode,
    "o-icon-sms": oIconSms,
    "o-icon-email": oIconEmail
  },
  data() {
    return {}
  },
  mounted() {
    Notification.add('Voorbeeld notificatie', Notification.TYPE.SUCCESS, 5000);
  }
}
